export default class ApiError extends Error {
  constructor(data: { [key: string]: any } = {}) {
    super(data.title || data.message || '');
    data.title = data.title || data.message;
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    Object.assign(this, data);
  }
}
